const createFormData = (formData: Record<string, any>) => {
  const result = new FormData();

  Object.entries(formData).forEach(([key, value]) => {
    result.append(key, value);
  });

  return result;
};

export { createFormData };
